<template>
  <div id="app">
    <div class="cont"></div>
    <img class="topImg" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/game_gy_top.png" alt="">
    <div class="gameIntroduction basic">
      <img class="titleImg" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/gameIntroductionTitle.png" alt="">
      <div class="imgBox">
        <img  @click="goDetail" class="gameIntroductionImg" @mouseover="showMask = true" @mouseout="showMask = false" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/gameIntroduction.png" alt="">
        <div  v-if="showMask" class="mosk">了解详情</div>
      </div>
      <div class="introduction">捣蛋鬼派对官方正版是一款类似太空狼人杀玩法的休闲竞技类手游。游戏玩法非常简单，寻找材料、维修机器、激活芯片，乘坐直升机离开荒岛，但是每一局游戏都会有一名捣蛋鬼，你需要联合队友找出捣蛋鬼并驱逐他，游戏才算胜利，感兴趣的小伙伴们快来下载游戏体验吧！</div>
    </div>
    <img  class="activity" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/activity.png" alt="">
    <div class="careerMap basic">
      <img class="titleImg" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/careerMapTitle.png" alt="">
      <swiper 
        class="swiper"
        :options="swiperOption" 
        ref="mySwiper"
        @slideChange="slideChange()"
        >
        <swiper-slide class="swiper-no-swiping" v-for="(item, index) in occupationList" :key="index">
          <img  v-if="activeIndex == index" class="swiperImg" :src="item.imgUrl">
        </swiper-slide>
        <div class="prev btn" slot="button-prev"><img src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/leftBtn.png" alt=""></div>
        <div class="next btn" slot="button-next"><img src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/rightBtn.png" alt=""></div>
      </swiper> 
    </div>
    <div class="contentDisplay basic">
      <img class="titleImg" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/contentDisplayTitle.png" alt="">
      <swiper :options="swiperOption" ref="mySwiper2" class="swiper">
         <swiper-slide  class="swiper-no-swiping" v-for="(item, index) in contentList" :key="index">
          <img class="swiperBg" src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/topAreaBg.png" alt="">
          <img class="swiperImg" :src="item.imgUrl">
        </swiper-slide>
        <div class="prev btn" slot="button-prev"><img src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/leftBtn.png" alt=""></div>
        <div class="next btn" slot="button-next"><img src="http://qnimage.jiefanco.cn/h5/game_gw_imgs/rightBtn.png" alt=""></div>
      </swiper> 
    </div>
    <div id="bottom">
      <div class="cont"></div>
    </div>
  </div>
</template>
<script>

import './sass/index.min.css'

export default {
  name: 'App',
  components: {

  },
  data(){
    return{
      showMask: false, // 初始化遮罩层不显示
      occupationList:[
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/magician.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/detective.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/fighter.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/huntsman.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/adventurer.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/locksmith.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/hollowMan.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/deserter.png'},
        ],
      contentList:[
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content1.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content2.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content3.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content4.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content5.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content6.png'},
          {imgUrl:'http://qnimage.jiefanco.cn/h5/game_gw_imgs/content7.png'},
        ],
      swiperOption:{
        noSwiping: true,
        // loop: true, // 循环吗
        initialSlide: 0, // 从第几个开始
        autoplay: {
          delay: 5000, // 等5秒下一个
          disableOnInteraction: false // 中间滑动一下，取消自动吗？
        },
        speed: 800, // 滑动时候动画的速度
        navigation: {
          prevEl: '.prev', // 左侧按钮
          nextEl: '.next' // 右侧按钮
        },
        effect: 'fade', // 渐入效果
     
      },
      activeIndex:0,//swiper当前索引
    }
  },

  methods: {
    goDetail(){
      window.open('detail/detail.html');
    },
    //轮播change事件
    slideChange(){
      this.activeIndex = this.$refs.mySwiper.swiper.realIndex
    } 
  },

}
</script>

